import { render, staticRenderFns } from "./Pull.vue?vue&type=template&id=bda767a4&scoped=true"
import script from "./Pull.vue?vue&type=script&lang=js"
export * from "./Pull.vue?vue&type=script&lang=js"
import style0 from "./Pull.vue?vue&type=style&index=0&id=bda767a4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bda767a4",
  null
  
)

export default component.exports